import { useMemo } from 'react';
import useChatContacts from './useChatContacts';
import isSupportPatient from '../../utils/isSupportPatient';

const useSupportContact = () => {
  const { contacts } = useChatContacts();
  const supportContact = useMemo(
    () => contacts.find(({ user }) => isSupportPatient(user)),
    [contacts],
  );
  return { ...supportContact };
};

export default useSupportContact;
